// ── Network Map Theme & Constants ──
// Dark palette aligned with CRM editor/sidebar colors

export const THEME = {
  bg: "#000925",
  surface: "#000f2d",
  surfaceHover: "#0a1a3d",
  border: "#1a2744",
  borderLight: "#2a3755",
  text: "#ffffff",
  textSecondary: "#c7c7cb",
  textDim: "#414b5f",
  accent: "#6366f1",

  nodeColors: {
    sector:      { fill: "#7C3AED", stroke: "#A78BFA", glow: "rgba(124,58,237,0.35)" },
    company:     { fill: "#0EA5E9", stroke: "#38BDF8", glow: "rgba(14,165,233,0.35)" },
    opportunity: { fill: "#F59E0B", stroke: "#FBBF24", glow: "rgba(245,158,11,0.35)" },
    contact:     { fill: "#10B981", stroke: "#34D399", glow: "rgba(16,185,129,0.35)" },
  },

  linkColors: {
    ownership:   "#0EA5E9",
    sector:      "#7C3AED55",
    involvement: "#10B98188",
    affiliation: "#0EA5E955",
    referral:    "#F59E0B88",
    shared:      "#EF444488",
  },

  stageColors: {
    lead:         "#94a3b8",
    qualified:    "#f59e0b",
    proposal:     "#6366f1",
    negotiation:  "#3b82f6",
    closed_won:   "#10b981",
    closed_lost:  "#ef4444",
    early:        "#6366F1",
    pitch:        "#8B5CF6",
    structuring:  "#F97316",
    active:       "#10B981",
  },
};

export const NODE_TYPE_LABELS = {
  sector: "Sector",
  company: "Company",
  opportunity: "Opportunity",
  contact: "Contact",
};

export const LINK_TYPE_LABELS = {
  ownership:   "Company \u2192 Opportunity",
  sector:      "Company \u2192 Sector",
  involvement: "Contact \u2192 Opportunity",
  affiliation: "Contact \u2192 Company",
  referral:    "Referral Chain",
  shared:      "Shared Contact",
};

export const formatCurrency = (value, symbol = "\u00a3") => {
  if (!value) return "";
  if (value >= 1e6) return `${symbol}${(value / 1e6).toFixed(1)}M`;
  if (value >= 1e3) return `${symbol}${(value / 1e3).toFixed(0)}K`;
  return `${symbol}${value}`;
};
